/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils.ts (VIP Lists Utilities)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Utility functions for VIP Lists module.
    Provides mapping, normalization, and transformation functions.

 🔧 Notes:
    - Type-safe transformations
    - Handles API response mapping

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import {
  FormState,
  VIPListResponse,
  VIPListMemberResponse,
  VIPListMember,
} from './types';

export const mapResponseToState = (
  list: VIPListResponse,
  members: VIPListMemberResponse[] = []
): FormState => {
  const mappedMembers: VIPListMember[] = members.map(member => ({
    id: member.id,
    vipListId: member.vipListId,
    callerIdNumber: member.callerIdNumber ?? '',
    callerIdName: member.callerIdName ?? '',
    priority: member.priority ?? 1,
    notes: member.notes ?? '',
    enabled: Boolean(member.enabled),
    createdAt: member.createdAt ?? null,
    createdBy: member.createdBy ?? null,
    updatedAt: member.updatedAt ?? null,
    updatedBy: member.updatedBy ?? null
  }));

  return {
    name: list.name ?? '',
    description: list.description ?? '',
    enabled: Boolean(list.enabled),
    createdAt: list.createdAt ?? null,
    updatedAt: list.updatedAt ?? null,
    members: mappedMembers
  };
};

